import { useEffect, useState } from 'react'
import { useLayoutStore } from '@/stores/layout'

export function useTheme() {
	const { theme, setTheme } = useLayoutStore()
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	useEffect(() => {
		if (!mounted) return

		const root = window.document.documentElement
		root.classList.remove('light', 'dark')

		if (theme === 'system') {
			root.classList.add(isSystemDark() ? 'dark' : 'light')
		} else {
			root.classList.add(theme)
		}
	}, [theme, mounted])

	// 监听系统主题变化
	useEffect(() => {
		if (theme !== 'system') return
		if (typeof window.matchMedia !== 'function') return

		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
		const handleChange = () => {
			const root = window.document.documentElement
			root.classList.remove('light', 'dark')
			root.classList.add(mediaQuery.matches ? 'dark' : 'light')
		}

		mediaQuery.addEventListener('change', handleChange)
		return () => mediaQuery.removeEventListener('change', handleChange)
	}, [theme])

	return {
		theme,
		setTheme,
		mounted,
		isDark: theme === 'dark' || (theme === 'system' && isSystemDark()),
	}
}

function isSystemDark() {
	return typeof window !== 'undefined'
		&& typeof window.matchMedia === 'function'
		&& window.matchMedia('(prefers-color-scheme: dark)').matches
}
